// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#cd-configurator ul.icons {\r\n  list-style-type:none;\r\n  margin-block-start: 1em;\r\n  margin-block-end: 0em;\r\n  margin-inline-start: 0px;\r\n  margin-inline-end: 0px;\r\n  padding-inline-start: 0px;\r\n  display: inline-flex;\r\n  padding-right: 20px;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
